import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { CallsPage } from 'src/modules/calls/components/pages/calls.page';
import { callsSearchSchema } from 'src/modules/calls/schemas/calls-search.schema';

export const Route = createFileRoute('/calls/')({
  component: CallsIndexComponent,
  validateSearch: (search) => callsSearchSchema.parse(search),
});

// Example to add nested routes
// https://tanstack.com/router/latest/docs/framework/react/examples/basic-file-based
function CallsIndexComponent() {
  return (
    <AuthenticateRoute>
      <CallsPage />
    </AuthenticateRoute>
  );
}
